import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import rootReducer, { RootState } from './rootReducer';
import { actionInterceptor } from './middleware/actionsInterceptorMiddleware';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (gDM) => {
    return gDM({
      serializableCheck: false,
    }).concat([actionInterceptor.middleWareFn as any]);
  },
});

export type AppStore = typeof store;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <State = RootState, PartState = unknown>(
  selector: (state: State) => PartState
): ReturnType<typeof selector> => useSelector<State, ReturnType<typeof selector>>(selector);

export default store;
